import styled from 'styled-components';

import { ListBoxOption as ListBoxOptionClass } from '@telialt/common-select-combo-box/src/SingleSelectComboBox/SingleSelectComboBox.styles';
import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { RatePlanTerms } from '../../product/RatePlanTerms';

export const RatePlanSelectorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
    position: relative;
`;

export const RatePlanOptionContainer = styled.div`
    display: flex;
    flex-wrap: nowrap;
    min-height: 3rem;
    line-height: 1rem;
    column-gap: ${getPurpurSpacing('200')};
    align-items: center;
`;

export const LeftColumn = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    column-gap: ${getPurpurSpacing('200')};
    align-items: baseline;
    word-break: break-word;
    white-space: break-spaces;
    row-gap: ${getPurpurSpacing('50')};

    ${purpurMedia('md')`
        flex-basis: 75%;
        flex-direction: row;
    `}
`;

export const RatePlanOptionDescription = styled.span`
    font-size: ${getPurpurTypography('scale75')};
`;

export const RatePlanOptionTerms = styled(RatePlanTerms)`
    font-weight: ${getPurpurTypography('weightMedium')};
    letter-spacing: 1px;
    color: ${getPurpurColor('purple900')};

    ${ListBoxOptionClass}[aria-selected='true'] & {
        color: white;
    }
`;

export const RightColumn = styled.div`
    display: flex;
    margin-left: auto;
    flex-direction: column;
    text-align: right;
    white-space: nowrap;
    row-gap: ${getPurpurSpacing('50')};
`;

export const RatePlanOptionOldPrice = styled.div`
    text-decoration: line-through;
    font-size: ${getPurpurTypography('scale75')};
`;

export const RatePlanOptionPrice = styled.div<{ $hasPromotion: boolean }>`
    color: ${({ $hasPromotion }) => ($hasPromotion ? getPurpurColor('red600') : 'inherit')};
    ${ListBoxOptionClass}[aria-selected='true'] & {
        color: white;
    }
`;
